import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setError, setLoading, setOpenModal, setIsSaved, setData } from "../../global-state/redux";
import "./Commandes.css";
import { data, urls, menu } from "../../constant";
import { getRequest, postRequest } from "../../network/httpRequest";
import { Container, MenuPager, HeaderPager } from "../../components";
import { ListCommandes, ImportFile, AffecterCommande } from "./small";

const Commandes = () => {
  //configuration pour le role
  const {
    dataUser,
    dataUser: {
      user: {
        auth: { roleId },
      },
    },
  } = useSelector((store) => store.user);
  let tabs = menu.tabsCommandes;
  //tabs si le role est vendeur
  if (roleId === 2) {
    tabs = tabs.filter((item) => item.id > 1);
  }

  const [tabIndex, setTabIndex] = useState(tabs[0]);
  const [vendeurs, setVendeurs] = useState([]);
  const [hasValidatedOrders, setHasValidatedOrders] = useState(false);
  const [validatedOrderIds, setValidatedOrderIds] = useState([]);
  const [validatedOrdersData, setValidatedOrdersData] = useState([]);
  const [showSyncDialog, setShowSyncDialog] = useState(false);
  const [syncDialogData, setSyncDialogData] = useState(null);
  const [isSyncing, setIsSyncing] = useState(false);
  const { open, actionName, number } = useSelector((store) => store.modal);
  const { data: selectedOrders } = useSelector((store) => store.data);
  const { isloading } = useSelector((store) => store.loading);
  const dispatch = useDispatch();
  
  const tabChanging = (data) => {
    setTabIndex(data);
  };

  const getVendeurs = async () => {
    dispatch(setLoading());
    const { err, msg, data, typeErr } = await getRequest(
      `${urls.statique}/users?role=2`
    );
    dispatch(setLoading());
    if (err) {
      return dispatch(setError({ err, msg, data, typeErr }));
    }
    setVendeurs(data);
  };

  const calculateTotals = (orders) => {
    let totalQuantity = 0;
    let totalAmount = 0;
    
    orders.forEach(order => {
      totalQuantity += parseFloat(order.qte || 0);
      totalAmount += parseFloat(order.qte || 0) * parseFloat(order.prixUnitaire || 0);
    });

    return { totalQuantity, totalAmount };
  };

  const handleBulkSync = async () => {
    // Validate selections
    if (selectedOrders.length === 0) {
      dispatch(setError({
        err: true,
        msg: "Veuillez sélectionner au moins une commande",
        typeErr: "VALIDATION"
      }));
      return;
    }

    // Get full order data for selected orders
    const selectedOrdersFullData = validatedOrdersData.filter(order =>
      selectedOrders.some(sel => sel.idcommande === order.id)
    );

    const { totalQuantity, totalAmount } = calculateTotals(selectedOrdersFullData);

    // Show confirmation dialog
    setSyncDialogData({
      type: 'bulk',
      orderCount: selectedOrders.length,
      totalQuantity,
      totalAmount,
      orders: selectedOrders
    });
    setShowSyncDialog(true);
  };

  const handleMassSync = async () => {
    // Sync all validated orders without requiring selection
    if (validatedOrderIds.length === 0) {
      dispatch(setError({
        err: true,
        msg: "Aucune commande validée à synchroniser",
        typeErr: "VALIDATION"
      }));
      return;
    }

    const { totalQuantity, totalAmount } = calculateTotals(validatedOrdersData);

    // Show confirmation dialog
    setSyncDialogData({
      type: 'mass',
      orderCount: validatedOrderIds.length,
      totalQuantity,
      totalAmount,
      orders: validatedOrderIds
    });
    setShowSyncDialog(true);
  };

  const confirmSync = async () => {
    setShowSyncDialog(false);
    setIsSyncing(true);

    dispatch(setLoading());

    const { err, msg, data, typeErr } = await postRequest(
      `${urls.commande}/sync-amount-bulk`,
      "json",
      { commandes: syncDialogData.orders }
    );
    dispatch(setLoading());
    setIsSyncing(false);

    if (err) {
      return dispatch(setError({ err, msg, data, typeErr }));
    }

    // Clear selected orders if bulk sync and refresh list
    if (syncDialogData.type === 'bulk') {
      dispatch(setData([]));
    }
    dispatch(setIsSaved());
  };

  const cancelSync = () => {
    setShowSyncDialog(false);
    setSyncDialogData(null);
  };

  useEffect(() => {
    getVendeurs();
  }, [selectedOrders]);
  
  return (
    <>
      <Container pageName={"commandes"}>
        <HeaderPager
          title={tabIndex.description}
          btnTitle="Importer Excel"
          showBtn={tabIndex.id < 2 ? true : false}
        />
        <MenuPager
          tabs={tabs}
          fxSelectedtab={tabChanging}
          defaultTab={roleId === 2 ? 2 : 0}
        />
        <MassSyncButton
          classCss={`${
            hasValidatedOrders && validatedOrderIds.length > 0 && roleId === 1 && selectedOrders.length === 0
              ? "show-btn"
              : "hidden-btn"
          }`}
          onSync={handleMassSync}
          isLoading={isSyncing}
        />
        <BulkSyncButton
          classCss={`${
            selectedOrders.length > 0 && roleId === 1 && hasValidatedOrders
              ? "show-btn"
              : "hidden-btn"
          }`}
          onSync={handleBulkSync}
          isLoading={isSyncing}
        />
        <BtnAffectation
          classCss={`${
            selectedOrders.length > 0 && roleId === 1 ? "show-btn" : "hidden-btn"
          }`}
        />
        {selectedOrders.length > 0 && roleId === 2 && <ValiderCommande />}

        <ListCommandes 
          tabIndex={tabIndex} 
          setHasValidatedOrders={setHasValidatedOrders}
          setValidatedOrderIds={setValidatedOrderIds}
          setValidatedOrdersData={setValidatedOrdersData}
        />
      </Container>
      {showSyncDialog && (
        <SyncConfirmationDialog
          data={syncDialogData}
          onConfirm={confirmSync}
          onCancel={cancelSync}
        />
      )}
      {tabIndex.id === 0 && open && actionName === "createData" && (
        <ImportFile />
      )}
      {tabIndex.id === 0 && open && actionName === "affecterCommande" && (
        <AffecterCommande vendeurs={vendeurs} />
      )}
    </>
  );
};

const BtnAffectation = ({ classCss }) => {
  const dispatch = useDispatch();
  return (
    <div className={`btn-affections ${classCss}`}>
      <div>
        <button
          className="btn info"
          onClick={() => {
            dispatch(setOpenModal({ actionName: "affecterCommande" }));
          }}
        >
          Affecter au vendeur
        </button>
      </div>
    </div>
  );
};

const BulkSyncButton = ({ classCss, onSync, isLoading }) => {
  return (
    <div className={`btn-affections ${classCss}`}>
      <div>
        <button
          className="btn info"
          onClick={onSync}
          disabled={isLoading}
          style={{ 
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.6 : 1
          }}
        >
          {isLoading ? "Synchronisation..." : "Sync Amount"}
        </button>
      </div>
    </div>
  );
};

const MassSyncButton = ({ classCss, onSync, isLoading }) => {
  return (
    <div className={`btn-affections ${classCss}`}>
      <div>
        <button
          className="btn info"
          onClick={onSync}
          disabled={isLoading}
          style={{ 
            backgroundColor: isLoading ? "#9ca3af" : "#047857",
            cursor: isLoading ? "not-allowed" : "pointer",
            opacity: isLoading ? 0.6 : 1
          }}
        >
          {isLoading ? "Synchronisation..." : "Mass Sync All VALIDER"}
        </button>
      </div>
    </div>
  );
};

const ValiderCommande = () => {
  const dispatch = useDispatch();
  return (
    <div className="btn-affections">
      <div>
        <button
          className="btn info"
          onClick={() => {
            dispatch(
              setOpenModal({
                actionName: "actionContent",
                data: [],
                actionTitle: `VALIDATION DE COMMANDES`,
                number: 4,
              })
            );
          }}
        >
          Valider
        </button>
      </div>
    </div>
  );
};

const SyncConfirmationDialog = ({ data, onConfirm, onCancel }) => {
  if (!data) return null;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-EN', {
      style: 'currency',
      currency: 'BIF',
      minimumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: "16px", color: "#0369a1" }}>
          Confirmation de Synchronisation
        </h3>
        <div style={{ marginBottom: "20px" }}>
          <p style={{ margin: "8px 0", fontSize: "14px" }}>
            <strong>Type:</strong>{" "}
            {data.type === "mass" ? "Synchronisation Massive" : "Synchronisation des Sélections"}
          </p>
          <p style={{ margin: "8px 0", fontSize: "14px" }}>
            <strong>Nombre de commandes:</strong> {data.orderCount}
          </p>
          <p style={{ margin: "8px 0", fontSize: "14px" }}>
            <strong>Quantité totale:</strong> {data.totalQuantity.toFixed(2)}
          </p>
          <p style={{ margin: "8px 0", fontSize: "14px" }}>
            <strong>Montant total:</strong> {formatCurrency(data.totalAmount)}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "1px solid #d1d5db",
              //backgroundColor: "white",
              color: "#000000",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#0369a1",
              color: "white",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Commandes;
